"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectorType = exports.RequestForInfoAction = void 0;
var RequestForInfoAction;
(function (RequestForInfoAction) {
    RequestForInfoAction["UNKNOWN"] = "UNKNOWN";
    RequestForInfoAction["ONBOARD"] = "ONBOARD";
    RequestForInfoAction["SURVEY"] = "SURVEY";
    RequestForInfoAction["BIRTHDAY"] = "BIRTHDAY";
})(RequestForInfoAction = exports.RequestForInfoAction || (exports.RequestForInfoAction = {}));
var SelectorType;
(function (SelectorType) {
    SelectorType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    SelectorType["GENRE"] = "GENRE";
    SelectorType["AD_EXPERIENCE"] = "AD_EXPERIENCE";
    SelectorType["DEMOGRAPHIC"] = "DEMOGRAPHIC";
    SelectorType["CELEBRITY"] = "CELEBRITY";
    SelectorType["GENERIC_SURVEY"] = "GENERIC_SURVEY";
    SelectorType["BIRTHDAY"] = "BIRTHDAY";
})(SelectorType = exports.SelectorType || (exports.SelectorType = {}));
//# sourceMappingURL=requestForInfoEvent.js.map